export default "__VITE_ASSET__7ba38866__"